/** @jsx jsx */
import { jsx } from "theme-ui"
import CollectionDetail from "../collection-detail"

const CollectionDetailPattern = ({ blade, ...restProps }) => {
  return <CollectionDetail sx={{ width: "100%" }} />
}

export default CollectionDetailPattern
